module.exports = __webpack_public_path__ + "static/undraw_cookie-0bec6693cebb31f6931469a2eb1979f5.svg";